export default __webpack_public_path__ + "static/media/long-term.f15bdb90.jpg";